import AppProvider from './context/AppContext';
import { ResponsesProvider } from './context/ResponseContext';
import { AppRouter } from './router';

function App() {
  return (
    <>
      <AppProvider>
        <ResponsesProvider>
          <AppRouter />
        </ResponsesProvider>
      </AppProvider>
    </>
  );
}

export default App;
